var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFixed = function SvgFixed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#404055"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M9.333 8.5a1.66 1.66 0 0 0-1.666 1.667V13.5a1.66 1.66 0 0 0 1.666 1.667h3.333c.925 0 1.667-.742 1.667-1.667v-3.333A1.66 1.66 0 0 0 12.666 8.5m.167 1.25.883.875-3.324 3.292-2.109-2.125.892-.875 1.225 1.241m-1.067 4.675A1.66 1.66 0 0 0 7.667 18.5v3.333A1.66 1.66 0 0 0 9.333 23.5h3.333c.925 0 1.667-.742 1.667-1.667V18.5c0-.925-.742-1.667-1.667-1.667M9.333 18.5h3.333v3.333H9.333M16 10.167h8.333v1.666H16m0 10v-1.666h8.333v1.666M16 15.167h8.333v1.666H16z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFixed);
export { ForwardRef as ReactComponent };